<template>
  <model-form
    ref="form"
    :model="planElement"
    :submodel="submodel"
    width="600px"
    modal-type="modal"
  >
    <q-tabs
      v-model="tab"
      align="justify"
      dense
    >
      <q-tab
        name="details"
        label="Details"
      />
      <q-tab
        name="overrides"
        label="Overrides"
      />
    </q-tabs>
    <q-tab-panels v-model="tab">
      <q-tab-panel name="details">
        <div class="row q-gutter-sm items-start justify-between">
          <div
            class="col-6"
          >
            <q-input
              v-model="planElement.name"
              :disable="!detailsEditable"
              label="Name"
              :autofocus="!$q.platform.is.ios"
              :rules="[val => !!val || 'Field is required']"
              bottom-slots
            />
            <q-tooltip v-if="!detailsEditable">
              Editable only in parent plan template
            </q-tooltip>
          </div>
          <q-btn
            class="col q-pt-xs"
            :style="{ 'background-color': `${planElement.color} !important` }"
            :color="planElement.color && $isColorDark(planElement.color) ? 'white' : 'black'"
            size="lg"
            glossy
            unelevated
            outline
            :disable="!detailsEditable"
          >
            <div class="text-caption text-weight-light">
              <div class="text-capitalize">
                Color
              </div>
              <div>{{ planElement.color }}</div>
            </div>
            <q-menu
              anchor="top left"
              self="top left"
            >
              <q-color v-model="planElement.color" />
            </q-menu>
            <q-tooltip v-if="!detailsEditable">
              Editable only in parent plan template
            </q-tooltip>
          </q-btn>
          <div class="col-auto q-ml-md q-my-none">
            <div class="text-caption text-dark">
              Title Count
            </div>
            <div class="row">
              <div
                :style="'color: ' + planElement.color + '; border-color: ' + planElement.color + '; background-color: ' + planElement.color + '33;'"
                class="title-count"
              >
                {{ planElement.titleCount }}
              </div>
              <div class="column q-ml-xs">
                <q-btn
                  size="sm"
                  icon="add"
                  dense
                  @click="planElement.titleCount += 1"
                />
                <q-btn
                  size="sm"
                  icon="remove"
                  dense
                  :disable="planElement.titleCount <= 1"
                  @click="planElement.titleCount -= 1"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row q-mt-xs q-mb-md">
          <showing-badge-select
            :model="planElement"
            class="col-12"
          />
        </div>
        <div class="row q-col-gutter-md justify-end">
          <q-checkbox
            v-model="planElement.default"
            :disable="!detailsEditable || planElement.isCustom"
            label="Include by Default"
          >
            <q-tooltip v-if="detailsEditable && !planElement.isCustom">
              If selected, this element will be automatically added to booking weeks by default
            </q-tooltip>
            <q-tooltip v-else>
              Editable only in parent plan template
            </q-tooltip>
          </q-checkbox>
        </div>
      </q-tab-panel>
      <q-tab-panel name="overrides">
        <div
          class="row q-col-gutter-md q-mb-sm"
        >
          <q-toggle
            v-model="planElement.overridePriceCard"
            class="col-6 q-pb-md"
            style="height: 92px;"
            label="Custom Price Card"
          />
          <q-select
            v-model="planElement.customPriceCard"
            class="col-6"
            label="Price Card"
            :options="$_.filter(priceCards.data, priceCard => !priceCard.isArchived)"
            option-label="name"
            :display-value="planElement.customPriceCard ? planElement.customPriceCard.name : ''"
            :disable="!planElement.overridePriceCard"
            bottom-slots
          />
          <q-toggle
            v-model="planElement.config.customSiteSchedule"
            class="col-12 q-pb-md"
            label="Custom Site Schedule"
          />
        </div>
        <site-schedule
          v-model="planElement.customSiteSchedule"
          :mode="planElement.config.customSiteSchedule ? 'edit' : 'read-only'"
        />
      </q-tab-panel>
    </q-tab-panels>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ShowingBadgeSelect from 'src/modules/admin/showing-badge/components/ShowingBadgeSelect'
import SiteSchedule from 'src/modules/admin/site-schedule/SiteSchedule'

export default {
  name: 'PlanElementForm',
  components: {
    ModelForm,
    SiteSchedule,
    ShowingBadgeSelect
  },
  configuration: ['currentSite', 'priceCards', 'showingBadges'],
  props: {
    submodel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  models: {
    planElement: {
      showingBadges: true,
      customPriceCard: true
    }
  },
  data () {
    return {
      tab: 'details'
    }
  },
  computed: {
    detailsEditable () {
      return this.planElement.isTemplate || this.planElement.isCustom
    }
  },
  methods: {
    show (model, initialData) {
      this.tab = 'details'
      this.$refs.form.show(model, initialData)
    }
  }
}

</script>

<style lang="scss" scoped>
  .title-count {
    text-align: center;
    width: 40px;
    height: 40px;
    font-size: 18px;
    line-height: 37px;
    border-radius: 100px;
    border: solid 1px;
  }
</style>
